import { Scene } from "../../tools/Scene";
import { LocalizationManager } from "../../managers/LocalizationManager";
import { GizmoAnimationScene } from "./GizmoAnimationScene";
import { PreloaderBGUIScene } from "./PreloaderBGUIScene";
import { GameManager } from "../../managers/GameManager";

export class PreloaderUIScene{

    bg:Phaser.GameObjects.Image|null = null;
    container:Phaser.GameObjects.Sprite|null = null;
    progressContainer:Phaser.GameObjects.Sprite|null = null;
    loadingText:Phaser.GameObjects.Text|null = null;
    blackbar:Phaser.GameObjects.Graphics|null = null;
    progress:Phaser.GameObjects.Graphics|null = null;
    progressBarPosition:Phaser.Math.Vector2|null = null;
    progressBarWidth:number|null = null;
    progressBarHeight:number|null = null;
    progressBarValue:number|null = null;
    progressBarNum:number|null = null;
    tapAnywhereText:Phaser.GameObjects.Text|null = null;
    uiSceneKey:string|null = null;

    uiScene:Scene;
    gizmoScene:Scene;

    scene:Scene;
    group:Phaser.GameObjects.Group;

    constructor(scene:Scene){

        this.scene = scene;
        this.group = scene.add.group({});

        this.uiSceneKey = 'PreloaderBGUIScene'+Math.random();

        this.uiScene = new PreloaderBGUIScene({key: this.uiSceneKey }, this);
        scene.scene.add(this.uiSceneKey,this.uiScene,true);

        console.log("Preload Start:"+scene.scene.settings.key);
        let position;

        // //Window
        position = scene.scaleManager.getRelativePosition(.5,.5);
        this.bg = scene.add.image(position.x,position.y,'lan_gen_bg');
        // this.bg.visible = false;
        this.container = scene.add.sprite(position.x,position.y,'gfx_loading');
        this.progressContainer = scene.add.sprite(position.x,position.y+60,'gfx_loading_bar_con');
        this.loadingText = scene.add.text(position.x-390,position.y+50,LocalizationManager.getText('LOADING'),LocalizationManager.getStyle('LOADING'));

        this.group.add(this.bg);
        this.group.add(this.container);
        this.group.add(this.loadingText);

        scene.anims.create({ key: 'gizmo_run', frames: scene.anims.generateFrameNames('gizmo', { prefix: 'gizmo_preloader', start: 0, end: 18, zeroPad: 4 }), repeat: -1, frameRate: 60});
        this.gizmoScene = new GizmoAnimationScene({key:'GizmoAnimationScene'+Math.random()});
        scene.scene.add('GizmoAnimationScene',this.gizmoScene,true);

        //Progress Bar
        this.progressBarWidth = 360;
        this.progressBarHeight = 30;

        let blackbar = scene.add.graphics({});
        blackbar.fillStyle(0x000000, 1);
        blackbar.fillRect(position.x, position.y,  this.progressBarWidth, this.progressBarHeight);
        this.blackbar = blackbar;
        this.group.add(this.blackbar);

        let progress = scene.add.graphics({});
        this.progress = progress;
        this.progressBarPosition = new Phaser.Math.Vector2(position.x,position.y);
        this.group.add(this.progress);

        scene.load.on('progress', this.moveProgressBar,this);
        scene.load.on('complete', this.onProgressBarComplete,this);

        this.reorient(scene.scaleManager.isOrientationLandscape());
        this.scene.scaleManager.rescale();

        //Add Scene event bindings
        this.scene.events.on('resize',this.onSceneResize,this);
    }

    reorient(landscape:boolean){
        let position;
        if(landscape){
            position = this.scene.scaleManager.getRelativePosition(.5,.5);

            if(this.bg){
                this.bg!.setPosition(position.x,position.y);
                this.bg!.setTexture('lan_gen_bg');
            }
            
            if(this.container){
                this.container!.setPosition(position.x,position.y-12);
            }
            
            if(this.progressContainer)
            {
                this.progressContainer!.setPosition(position.x,position.y+70);
            }
            
            if(this.loadingText){
                this.loadingText!.setPosition(position.x-195,position.y+40);
            }
            

            //Progress Bar
            this.progressBarPosition = new Phaser.Math.Vector2(position.x-180,position.y+60);
            this.progressBarWidth = 360;
            this.progressBarHeight = 30;

            if(this.blackbar)
            {
                this.blackbar!.clear();
                this.blackbar!.fillStyle(0x000000, 1);
                this.blackbar!.fillRect(this.progressBarPosition.x, this.progressBarPosition.y , this.progressBarWidth!, this.progressBarHeight!);
            }
            
            
            if(this.tapAnywhereText){
                position = this.scene.scaleManager.getRelativePosition(.5,.5);
                this.tapAnywhereText.setPosition(position.x,position.y+75);
            }
            
        }else{
            position = this.scene.scaleManager.getRelativePosition(.5,.5);

            if(this.bg)
            {
                this.bg!.setPosition(position.x,position.y);
                this.bg!.setTexture('por_gen_bg');
            }
            
            if(this.container){
                this.container!.setPosition(position.x,position.y-12);
            }
           
            if(this.progressContainer){
                this.progressContainer!.setPosition(position.x,position.y+70);
            }
            
            if(this.loadingText){
                this.loadingText!.setPosition(position.x-195,position.y+40);
            }
            

            //Progress Bar
            this.progressBarPosition = new Phaser.Math.Vector2(position.x-180,position.y+60);
            this.progressBarWidth = 360;
            this.progressBarHeight = 30;

            if(this.blackbar)
            {
                this.blackbar!.clear();
                this.blackbar!.fillStyle(0x000000, 1);
                this.blackbar!.fillRect(this.progressBarPosition.x, this.progressBarPosition.y , this.progressBarWidth!, this.progressBarHeight!);
            }  
           
            if(this.tapAnywhereText){
                position = this.scene.scaleManager.getRelativePosition(.5,.5);
                this.tapAnywhereText.setPosition(position.x,position.y+75);
            }
        }
        this.moveProgressBar(this.progress);
        this.rescaleBackground();
    }

    rescaleBackground():void {
        //rescale background
        let ratio = this.scene.scaleManager.getRatio();

        if(this.bg){
            if(this.bg!.width * this.bg!.scaleX != window.innerWidth || this.bg!.height * this.bg!.scaleY != window.innerHeight)
            {
                this.bg!.setScale(this.scene.sys.canvas.width/this.bg!.width / ratio! , this.scene.sys.canvas.height/this.bg!.height / ratio!);
            }
        }
        
    }

    moveProgressBar (value) {
        this.progressBarNum = value;
        // this.progress!.clear();
        // this.progress!.fillStyle(0x1999f1, 1);
        // this.progress!.fillRect(this.progressBarPosition!.x, this.progressBarPosition!.y, this.progressBarWidth! * value, this.progressBarHeight!);
        // this.progressBarValue = value;
    }

    onSceneResize(event:Phaser.Scene):void {

        this.rescaleBackground();
    }

    onProgressBarComplete () {
        this.blackbar!.destroy();
        this.progress!.destroy();
        this.loadingText!.setVisible(false);

        // console.log('IOS:'+this.scene.gameManager!.game!.device.os.iOS +   " iPhone:"+this.scene.gameManager!.game!.device.os.iPhone + " iPAD:"+this.scene.gameManager!.game!.device.os.iPad);
        if((this.scene.gameManager!.game!.device.os.iOS || this.scene.gameManager!.game!.device.os.iPhone || this.scene.gameManager!.game!.device.os.iPad)&& this.scene.gameManager.initialClick == false){
            
            let position = this.scene.scaleManager.getRelativePosition(.5,.5);
            let text = this.scene.add.text(position.x,position.y+80,LocalizationManager.getText('TAP_ANYWHERE'),LocalizationManager.getStyle('TAP_ANYWHERE'));
            text.setOrigin(0.5);
            this.tapAnywhereText = text;
            this.scene.input.on('pointerdown',()=>{
                this.scene.scene.remove(this.gizmoScene);

                if(this.progressContainer) this.progressContainer!.destroy();
                this.progressContainer = null;

                if(this.container) this.container!.destroy();
                this.container = null;

                if(this.bg) this.bg!.destroy();
                this.bg = null;

                if(this.container) this.container!.destroy();
                this.container = null;

                if(this.loadingText) this.loadingText!.destroy();
                this.loadingText = null;

                if(this.tapAnywhereText) this.tapAnywhereText!.destroy();
                this.tapAnywhereText = null;

                // if(this.group)
                // {
                //     this.group.destroy();
                // }

                // this.progressBarPosition = null;
                // this.progressBarWidth = null;
                // this.progressBarValue = null;
                // this.progressBarNum = null;
                // this.uiSceneKey = null;
                
                this.scene.gameManager.initialClick = true;
            });
            
        }
        else
        {
            this.scene.scene.remove(this.gizmoScene);

            if(this.progressContainer) this.progressContainer!.destroy();
            this.progressContainer = null;

            if(this.container) this.container!.destroy();
            this.container = null;

            if(this.bg) this.bg!.destroy();
            this.bg = null;

            if(this.container) this.container!.destroy();
            this.container = null;

            if(this.loadingText) this.loadingText!.destroy();
            this.loadingText = null;

            if(this.tapAnywhereText) this.tapAnywhereText!.destroy();
            this.tapAnywhereText = null;

            // if(this.group)
            // {
            //     this.group.destroy();
            // }

            // this.progressBarPosition = null;
            // this.progressBarWidth = null;
            // this.progressBarValue = null;
            // this.progressBarNum = null;
            
            
        }

        this.scene.scene.manager.stop(this.uiSceneKey!);
        this.scene.scene.manager.remove(this.uiSceneKey!);

        this.uiSceneKey = null;
        
    }
}